// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jr9Xuu {
  display: flex;
  gap: var(--spacing-0-5);
}
.P5MoBg {
  color: var(--text-neutral-stronger);
  font-size: var(--type-label-sm-font-size);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-160);
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/InputError/InputError.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,uCAAuC;EACvC,mCAAmC;AACrC","sourcesContent":[".inputErrorContainer {\n  display: flex;\n  gap: var(--spacing-0-5);\n}\n.inputErrorText {\n  color: var(--text-neutral-stronger);\n  font-size: var(--type-label-sm-font-size);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-160);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputErrorContainer": `jr9Xuu`,
	"inputErrorText": `P5MoBg`
};
module.exports = ___CSS_LOADER_EXPORT___;
